import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const MORPHO_VAULTS_URL = 'https://blue-api.morpho.org/graphql'
const csusdl = 'Coinshift USDL Morpho Vault::CSUSDL'

// csUSDL is a HOLDER-TOTAL figure, and legitimately differs from what the
// Morpho vault provider reports for this same vault:
//
//   intrinsic csUSDL = vault net-of-fee APR  +  underlying wUSDL yield
//   vaults/morpho    = vault net-of-fee APR   (only the lending leg)
//
// The extra leg is real: Morpho reports the underlying asset's own yield
// (`asset.yield.apr`) SEPARATELY from the vault's allocation APY
// (`state.apy`/`netApy`) — for a yield-bearing collateral like wUSDL that
// yield accrues to holders on top of the lending APY, so the intrinsic map
// ("what does holding this token earn") sums them.
//
// Units (verified against the live API): `state.apy`, `state.netApy` and
// `asset.yield.apr` are all FRACTIONS (e.g. 0.033 = 3.3%). So:
//   - the vault leg is `netApy` (post-fee, holder-accurate) run through
//     `apyToAprPercent(netApy * 100)` — the ×100 lifts the fraction to a
//     percent BEFORE the APY→APR conversion, matching `vaults/morpho`;
//   - the underlying leg is already an APR, so a plain `* 100` scales the
//     fraction to a percent.
// (The previous `apyToAprPercent(state.apy) * 100` fed a fraction where a
// percent was expected — the scale came out right but the APY→APR
// compounding was applied at 1/100 scale, i.e. effectively skipped, and it
// used gross `apy` instead of `netApy`.)

export const csusdlFetcher: YieldFetcher = {
  label: 'CSUSDL',
  fetch: async () => {
    const res = await fetch(MORPHO_VAULTS_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: JSON.stringify({
        query:
          'query GetAllCurrentAPYFromVault($address: String!) {\n  vaultByAddress(address: $address) {\n    state {\n      apy\n      netApy\n    }\n    asset {\n      yield {\n        apr\n      }\n    }\n  }\n}',
        variables: {
          address: '0xbEeFc011e94f43b8B7b455eBaB290C7Ab4E216f1',
        },
      }),
    }).then((r) => r.json())
    const vba = res?.data?.vaultByAddress
    const netApyFraction = vba?.state?.netApy ?? vba?.state?.apy ?? 0
    const underlyingAprFraction = vba?.asset?.yield?.apr ?? 0
    return {
      [csusdl]:
        apyToAprPercent(netApyFraction * 100) + underlyingAprFraction * 100,
    }
  },
}
